import { redirect } from "react-router-dom";
import { COMPLAINT_TYPE_POST_API, 
         COMPLAINT_TYPE_PATCH_API, 
         COMPLAINT_TYPE_DELETE_API } from '../../constants/apis';
import { COMPLAINT_TYPE_LIST_PATH, LOGIN_PATH } from '../../constants/paths';
import { postModel, patchModel, deleteModel } from '../../utils/functions';
import { DEFAULT_UNKNOWN_ERROR_MESSAGE } from '../../constants/constants';


export async function complaintTypeAction({ params, request }) {
    const requestData = await request.json();

    let data;

    if (requestData !== null) {
        if (requestData.resetWarnings) {        
            return {
                message: "",
                parameters: []
            };
        }
    
        data = requestData.data;
    }    

    try {
        switch (request.method) {
            case "POST":
                await postModel(COMPLAINT_TYPE_POST_API, data);

                return redirect(COMPLAINT_TYPE_LIST_PATH);
            case "PATCH":
                await patchModel(`${COMPLAINT_TYPE_PATCH_API}${params.complaint_type_id}`, data);

                return redirect(COMPLAINT_TYPE_LIST_PATH);
            case "DELETE":
                await deleteModel(`${COMPLAINT_TYPE_DELETE_API}${params.complaint_type_id}`);
                
                return redirect(COMPLAINT_TYPE_LIST_PATH);
            default:
                return {
                    message: "Esta página possui erros de implementação/desenvolvimento.",
                    parameters: []
                };
        }
    }
    catch(errors) {
        let message = [];
        let parameters = [];

        if(errors instanceof Array) {
            for(let error of errors) {
                if(error.code === 102) {
                    for(let parameter of error.parameters) {
                        if(parameter.name === 'critical_threshold' ||
                           parameter.name === 'moderate_threshold' ||
                           parameter.name === 'light_threshold' ||
                           parameter.name === 'very_light_threshold'
                        ) {
                            message.push('Faixas de risco devem estar entre 0 e 100');
                        }
                    }
                }
                else if(error.code === 103) {
                    for(let parameter of error.parameters) {
                        if(parameter.name === 'name') {
                            message.push('Nome já cadastrado');
                            parameters.push('name');
                        }
                    }
                }
                else if(error.code === 208) {
                    if(error.message.includes('id might be invalid')) {
                        message.push('Queixa não encontrada');
                    }
                }
                else if(error.code === 209) {
                    // message.push('Sessão do usuário expirada');
                    return redirect(LOGIN_PATH);
                }
            }
        }

        if (message.length <= 0) {
            message = [DEFAULT_UNKNOWN_ERROR_MESSAGE];
        }
    
        return {
            parameters,
            message: `${message.join('; ')}.`
        };
    }
  };